// auth/registerWorkspaceHostAuth.ts
//
// Hands this host shell's already-authenticated getAccessToken() to the
// kciWorkspace Module Federation remote (via its exposed './authBridge')
// so the remote reuses the host's MSAL session/token as single sign-on
// instead of running its own independent login flow. Called from every
// Remote*.tsx lazy loader before the remote component ever renders;
// memoized so concurrent/repeated mounts only register once.

import { getAccessToken } from './msalConfig';

let registerPromise: Promise<void> | null = null;

export function registerWorkspaceHostAuth(): Promise<void> {
  if (!registerPromise) {
    registerPromise = import(
      // @ts-expect-error kciWorkspace is a Module Federation remote defined in vite.config.ts
      'kciWorkspace/authBridge'
    )
      .then((authBridge: { registerHostAccessTokenProvider: (fn: () => Promise<string | null>) => void }) => {
        authBridge.registerHostAccessTokenProvider(getAccessToken);
      })
      .catch((error) => {
        console.error(
          '[kci-core] Failed to register host auth with kciWorkspace remote; it will fall back to its own login flow.',
          error
        );
        registerPromise = null;
      });
  }
  return registerPromise;
}
